import { TCloudAPIResponse } from "@/types/app";
import axios from "axios";
import { TPricingDisplayData } from "../../shared/types";
import { PAYMENT_V2_ENDPOINT_V2 } from "../constants.pricing";

const APIURL = `${PAYMENT_V2_ENDPOINT_V2}/pricing/others`;

type TResponse = TCloudAPIResponse<TPricingDisplayData | null>;

export const fetchPricingDisplayV2 = async (
  appLang: string = "en",
  token: string | undefined,
) => {
  try {
    const response = await axios.get(APIURL, {
      headers: {
        lang: appLang || "en",
        ...(token ? { Authorization: "Bearer " + token } : {}),
      },
    });

    const resData = response.data as TResponse;
    return resData.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
};
